type HostnameInterface = {
    hostname: Location["hostname"];
};

export const getHostname = (location: HostnameInterface) => location.hostname;

type HrefInterface = {
    href: Location["href"];
};

export const setHref = (location: HrefInterface, href: HrefInterface["href"]) => location.href = href;

type OriginInterface = {
    origin: Location["origin"];
};

export const getOrigin = (location: OriginInterface) => location.origin;

type PathnameInterface = {
    pathname: Location["pathname"];
};

export const getPathname = (location: PathnameInterface) => location.pathname;

type SearchInterface = {
    search: Location["search"];
};

export const getSearch = (location: SearchInterface) => location.search;
